//
//
//
//
//

export default {
  name: 'Cont404'
};